import type { MigrationStrategies } from 'rxdb';
import type { LineandSectionPropertiesListDocument } from './lineandSectionPropertiesDetails.types';
import { getValueFromLocalStorage } from '../share/defaultDoc';

export const lineandSectionPropertiesListMigrationStrategies: MigrationStrategies = {
  1: (oldDoc: LineandSectionPropertiesListDocument) => ({
    ...oldDoc,
    siteId: JSON.parse(getValueFromLocalStorage('selectedSite'))?.selectedSiteId || 0,
    disciplineId:
      JSON.parse(getValueFromLocalStorage('selectedDiscipline'))?.selectedDisciplineId || 0,
  }),
  2: (oldDoc: LineandSectionPropertiesListDocument) => ({
    ...oldDoc,
    assetSection: oldDoc.assetSection.map(item => {
      return { ...item, ksi: item.ksi || 0 };
    }),
  }),
};
